<template>
  <div class="resource-library-container">
    <DialogWrapper
      class="resource-library"
      hasCustomTitle
      closeOnCancel
      :show.sync="isShow"
      :close-on-click-modal="false"
      :loading="loading"
      :appendToBody="appendToBody"
      @save="handelConfirm"
      @cancel="handelCancel"
    >
      <template #title>
        <div class="title">
          <div class="label">{{ $t(`${i18nPrefix}.label.videoSourceLibrary`) }}</div>
          <i class="add-btn iconfont iconAdd" @click="handleAddBtnClick"></i>
        </div>
      </template>
      <div class="content">
        <div class="resource-list">
          <div
            v-for="(item, index) in resourceList"
            :key="index"
            class="resource"
          >
            <div class="video-wrapper" :class="checkedResourceIdList.includes(item.id) && 'active'" @click="handleSelectVideo(item)">
              <video
                class="video"
                controlslist="nodownload"
                :ref="`videoPlayer_${item.id}`"
                :src="item.resource_url"
                :controls="item.hasControls"
                @play="handleVideoPlay(item)"
              ></video>
              <div v-show="!item.hasControls" class="play-icon el-icon-video-play" @click="handlePlayerClick(item)"></div>
              <div class="radio-selector" :class="checkedResourceIdList.includes(item.id) && 'el-icon-check'"></div>
            </div>
            <div class="description">{{ item.name }}</div>
          </div>
        </div>
      </div>
    </DialogWrapper>
    <ResourceUploaderDialog :show.sync="resourceUploaderShow" :appendToBody="appendToBody" @uploaded="handleUploaded" />
  </div>
</template>

<script>
import DialogWrapper from '@/components/dialog/dialogWrapper.vue'
import ResourceUploaderDialog from './resourceUploaderDialog.vue'
import { getFilePath } from '@/utils/qiniu'
import _ from 'lodash'
import { mapActions } from 'vuex'

export default {
  components: {
    DialogWrapper,
    ResourceUploaderDialog
  },
  props: {
    show: {
      type: Boolean,
      required: true
    },
    isReplace: {
      type: Boolean,
      required: false
    },
    appendToBody: {
      type: Boolean,
      default: false
    },
    editVideo: {
      type: Object,
      default: () => null
    }
  },
  data () {
    return {
      i18nPrefix: 'admin.job.editor',
      checkedResourceIdList: [],
      resourceUploaderShow: false,
      loading: false,
      resourceList: []
    }
  },
  computed: {
    isShow: {
      get () {
        return this.show
      },
      set (val) {
        this.$emit('update:show', val)
      }
    }
  },
  created () {

  },
  mounted () {
  },
  methods: {
    ...mapActions('resourceLibrary', ['getResourceLibraryInfo', 'uploadResourceToLibrary']),
    async getVideoList () {
      try {
        this.loading = true
        const resp = await this.getResourceLibraryInfo({
          need_all: true
        })
        if (resp) {
          this.resourceList = _.map(resp.resource_library, item => ({ ...item, hasControls: false }))
        }
      } finally {
        this.loading = false
      }
    },
    handelConfirm () {
      if (this.checkedResourceIdList.length < 1) {
        return this.$message.warning(this.$t(`${this.i18nPrefix}.resourceLibrary.requiredVideo`))
      }
      this.$emit('confirm', _.filter(this.resourceList, item => this.checkedResourceIdList.includes(item.id)))
    },
    handelCancel () {
      this.$emit('cancel')
    },
    handleAddBtnClick () {
      this.resourceUploaderShow = true
    },
    handleUploaded (id, fileKey) {
      if (!id) {
        this.getVideoList()
      } else {
        this.resourceList.push({
          id: id,
          url: getFilePath(fileKey)
        })
      }
    },
    handlePlayerClick (item) {
      this.$refs[`videoPlayer_${item.id}`][0].play()
      item.hasControls = true
    },
    handleSelectVideo (item) {
      const hasSelected = this.checkedResourceIdList.includes(item.id)
      if (hasSelected) {
        this.checkedResourceIdList = _.filter(this.checkedResourceIdList, checkedResourceId => checkedResourceId !== item.id)
        return
      }

      this.isReplace ? this.checkedResourceIdList = [item.id] : this.checkedResourceIdList.push(item.id)
    },
    handleVideoPlay (item) {
      this.pauseAllVideo(item.id)
    },
    /**
     * 所有在播放的视频都暂停
     * @param {*} ignore 可通过传入的id来指定视频不会被此方法暂停
     */
    pauseAllVideo (ignore) {
      _.forEach(this.resourceList, (item, index) => {
        const player = this.$refs[`videoPlayer_${item.id}`][0]
        if (ignore === item.id) {
          return
        }
        if (!player.paused) {
          player.pause()
        }
      })
    }
  },
  watch: {
    show () {
      if (this.show) {
        this.checkedResourceIdList = [this.editVideo?.video_id]
        this.getVideoList()
      } else {
        this.pauseAllVideo()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.resource-library {
  ::v-deep .el-dialog {
    width: 860px;

    .el-dialog__header {
      padding: 34px 50px 0px;

    }
  }

  .title {
    display: flex;
    align-items: center;

    .label {
      font-size: 22px;
      font-weight: bold;
      color: #303133;
      line-height: 24px;
    }

    .add-btn {
      margin-left: auto;
      margin-right: 22px;
      display: inline-block;
      font-size: 34px;
      cursor: pointer;
      color: #0096CC;
    }
  }

  .resource-list {
    display: flex;
    flex-wrap: wrap;

    .resource {
      margin-bottom: 15px;
      margin-right: 15px;

      .video-wrapper {
        position: relative;
        cursor: pointer;
        line-height: 1;

        .video {
          background-color: #000;
          height: 150px;
          width: 240px;
          border: 4px solid #fff;
        }

        .play-icon {
          position: absolute;
          left: 15px;
          bottom: 15px;
          font-size: 18px;
          color: rgba(255, 255, 255, .7);
        }

        .radio-selector {
          position: absolute;
          top: 10px;
          right: 10px;
          width: 25px;
          height: 25px;
          line-height: 25px;
          text-align: center;
          border: 2px solid #0096cc;
          border-radius: 50%;
          color: #fff;
          transition: all .3s;
          z-index: 1;
        }

        &.active {
          .video {
            border: 4px solid #0096cc;
          }

          .radio-selector {
            background-color: #0096cc;
          }
        }
      }

      .description {
        color: #b6b6b6;
        padding: 0 4px;
        line-height: 1;
      }
    }
  }
}
</style>
